<template>
  <div>
    <el-table :data="table"
              stripe
              highlight-current-row
              border
              style="width: 100%">

      <template v-for="(attr, index) of fields">
        <el-table-column v-if="attr.prop === 'business_type_json'"
                         v-bind="attr">
          <template slot-scope="scope">
            <span>{{getBusinessType(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else v-bind="attr"></el-table-column>
      </template>

      <el-table-column prop="workcard_photo"
                       label="工作证"
                       key="workcard_photo">
        <template slot-scope="scope">
          <div :id="`photoContainer${scope.$index}`" style="width: 100%; overflow-x: auto; display: flex; flex-direction: row; align-items: center;">
            <template v-for="(photo, index) in scope.row.content.workcard_photo">
              <!-- 视频类型 -->
              <video v-if="isVideoFile(photo)"
                     :key="'video-' + index"
                     :src="photo"
                     preload="metadata"
                     style="width:80px;height:80px;margin:10px;object-fit:cover;flex-shrink:0;position:relative;cursor:pointer;background-color:#a9a5a5ff;"
                     @click="onPreviewVideo(photo, scope.row)">
              </video>
              <!-- 图片类型 -->
              <img v-else
                   :key="'img-' + index"
                   :src="photo | ossFormatJpg"
                   @click="onViewPhotos(index,scope.$index)"
                   class="avatar"
                   style="width:80px;height:80px;padding:10px;cursor: zoom-in;flex-shrink:0;"
                   alt="">
            </template>
          </div>
        </template>
      </el-table-column>

    </el-table>
    <div class="pagination">
      <el-pagination background
                     @size-change="handleSizePageChange"
                     @current-change="handleCurrentPageChange"
                     :current-page="pagination.current_page"
                     :page-sizes="[20, 50, 100, 200]"
                     :page-size="pagination.per_page"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 视频预览弹窗（复用功能更完整的 VideoPlayerDialog 组件） -->
    <video-player-dialog
      :visible.sync="videoPreviewVisible"
      :videos="videoPreviewVideos"
      :index="videoPreviewIndex" />
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import VideoPlayerDialog from '@views/user-workinfo/components/VideoPlayerDialog.vue'

export default {
  mixins: [table, userWorkInfoMixin],
  components: {VideoPlayerDialog},
  data () {
    return {
      id: this.$route.query.userid || 0,
      fields: [
        {prop: 'id', label: 'ID', width: 80},
        {prop: 'created_at', label: '更新时间', width: 160},
        {prop: 'updated_by', label: '更新人', width: 120},
        {prop: 'audited_by', label: '审核人', width: 150},
        {prop: 'business_type_json', label: '行业', width: 150},
        {prop: 'work_type_cn', label: '工种', width: 120},
        {prop: 'content.belongto', label: '厂家', width: 150},
      ],
      videoPreviewVisible: false,
      videoPreviewVideos: [],
      videoPreviewIndex: 0,
    }
  },
  computed: {
    ...Vuex.mapState({
      userOptions: state => state.users.userOptions,
    })
  },
  watch: {},
  async created () {
    await this.$store.dispatch('getUserRelatedOptions')
  },
  mounted () { },
  methods: {
    ...Vuex.mapActions([]),

    getTableData (params) {
      params.userid = this.id
      return request.page('getUserWorkInfoLog', params)
    },
    onViewPhotos (index, i) {
      if (this.viewer) {
        this.viewer.destroy()
      }
      this.viewer = new Viewer(document.getElementById(`photoContainer${i}`))
      this.viewer.view(index)
    },
    getBusinessType (row) {
      const businessTypeId = _.get(row, 'content.business_type')
      const businessTypeObj = this.userOptions.business_type.find(it => it.id + '' === businessTypeId + '')
      return _.get(businessTypeObj, 'title', '-')
    },
    onPreviewVideo (url, row) {
      // 构造当前行所有视频 URL 列表，并计算点击视频的索引，交给 VideoPlayerDialog 播放
      const videoList = (row.content.workcard_photo || []).filter(photo => this.isVideoFile(photo))
      this.videoPreviewVideos = videoList
      this.videoPreviewIndex = Math.max(videoList.indexOf(url), 0)
      this.videoPreviewVisible = true
    },
  },
}
</script>
<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/users/pages/detail/UsersDetailWorkInfoLog.vue